// extracted by mini-css-extract-plugin
export default {"shortDividerContainer":"ShortDivider_shortDividerContainer__3yvWU","shortDivider":"ShortDivider_shortDivider__GUiH0"};